import {DataResource} from '@/models/Response'
import moment from 'moment-timezone'

import Helper from '../services/Helper.js'

export class SimpleResponse {
    constructor(data: any) {
        this.data = data
    }

    public data: any = {}

    toString() {
        return this.data.message
    }
}


export abstract class Model {
    id?: number | null = null
    _save_state: string | null


    abstract getResourceURL(): string;

    public async load<T extends Model>(id: number): Promise<T> {
        console.log('Model load')
        return await new Promise<T>((resolve, reject) => {
            Helper.get(this.getResourceURL().replace('{id}', id.toString()))
                .then<{ data: DataResource }>(({data}) => resolve(data.data))
                .catch((e) => reject(e))
        })
    }

    public async save<T extends Model>(): Promise<T> {
        return await new Promise<T>((resolve, reject) => {
            console.log(['before', this])

            var stringify = JSON.stringify(this)
            var regex = /[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}\.0+Z/;

            let match;
            while (match = regex.exec(stringify)) {
                const replaceStr = moment(match[0]).tz('Asia/Bangkok').format('YYYY-MM-DDTHH:mm:ss')+'+0700'
                stringify = stringify.replace(match[0], replaceStr);
            }
            let obj: T = JSON.parse(stringify)
            console.log(['after', obj])

            this.getSkipField().forEach(e => delete obj[e])


            if (this.id) {
                Helper.put(this.getResourceURL().replace('{id}', this.id.toString()), obj)
                    .then<{ data: DataResource }>(({data}) => resolve(data.data))
                    .catch((e) => reject(e))
            } else {
                delete obj.id
                Helper.post(this.getResourceURL().replace('/{id}', ''), obj)
                    .then<{ data: DataResource }>(({data}) => resolve(data.data))
                    .catch((e) => reject(e))
            }
        })
    }

    public async delete(): Promise<any> {
        return await new Promise<any>((resolve, reject) => {
            let obj = JSON.parse(JSON.stringify(this))
            this.getSkipField().forEach(e => delete obj[e])

            if (this.id) {
                Helper.deleted(this.getResourceURL().replace('{id}', this.id.toString()), obj)
                    .then<{
                        data: DataResource
                    }>(({data}) => data.success ? resolve(new SimpleResponse(data)) : reject(new SimpleResponse(data)))
                    .catch((e) => reject(e))
            } else {
                resolve(true)
            }
        })
    }

    dirty() {
        this._save_state = 'dirty'
        console.log((typeof this) + ' dirty')
    }

    undirty() {
        this._save_state = 'saved'
        console.log((typeof this) + ' saved')
    }

    async gracefulSave<T extends Model>(): Promise<any> {
        if (this._save_state == 'dirty') {
            const obj: T = await this.save<T>()
            Object.assign(this, obj)
            this._save_state = 'saved'
            console.log((typeof this) + ' saved')
        }
        return this
    }

    getSkipField(): string[] {
        return []
    }
}

//Object.setPrototypeOf(this.selectedUser, User.prototype)

export const ModelHelper = Object.freeze({
    convert<T extends Model>(obj: any, tCasss): T {
        return Object.setPrototypeOf(obj, tCasss.prototype)
    }
})
